import request from '../request'

/**
 * 分类相关API接口
 */

/**
 * 获取分类列表
 * @returns {Promise} 返回分类列表数据
 */
export const getCategoryList = () => {
  return request('/api/Category/getCategoryList', {}, 'get')
}

/**
 * 获取专业大类列表
 * @returns {Promise} 返回专业大类列表数据
 */
export const getMajorList = () => {
  return request('/api/Subspecialty/getMajorList', {}, 'get')
}

/**
 * 获取大学详情信息
 * @param {Object} params - 请求参数
 * @param {number} params.university_id - 大学ID (必填)
 * @returns {Promise} 返回大学详情数据
 */
export const getUniversityInfo = (params = {}) => {
  return request('/api/Subspecialty/getUniversityInfo', params, 'get')
}

export default {
  getCategoryList,
  getMajorList,
  getUniversityInfo
}

